// Generated by `npm run data:reef-bottom` (scripts/data/reefBottom.ts) from the NCRMP
// extract in data/ncrmp-benthic-strs/. Do not edit by hand: change the script
// and run it. tests/reefBottom.test.ts builds it again and fails if this file
// is not what the archive gives.
import type { DepthBin, ReefIsland } from '../../reef';

/** A stratum's bottom: of the points on the bottom at its site visits, each category's mean share, percent. */
export interface StratumBottom {
  island: ReefIsland;
  bin: DepthBin;
  sites: number;
  sedimentPercent: number;
  turfPercent: number;
  corallinePercent: number;
  macroalgaePercent: number;
  coralPercent: number;
}

/**
 * The reef's bottom, stratum by stratum (M118), in `stratumIndex` order: NOAA's surveys' site visits in the square,
 * 2015 to 2024, each its points' shares by category, their mean (Ecosystem Sciences Division, Pacific Islands Fisheries
 * Science Center (2026), NCEI Accession 0317464, CC0 1.0). MEASURED by the script. Drawn, never simulated: the
 * Maui Nui Reef habitat's sand and pavement (`reefScene.ts`).
 */
export const REEF_BOTTOM: readonly StratumBottom[] = [
  { island: 'maui', bin: 'shallow', sites: 41, sedimentPercent: 10.73, turfPercent: 62.35, corallinePercent: 1.666, macroalgaePercent: 2.543, coralPercent: 22.362 },
  { island: 'maui', bin: 'mid', sites: 39, sedimentPercent: 13.712, turfPercent: 53.973, corallinePercent: 3.148, macroalgaePercent: 4.627, coralPercent: 24.454 },
  { island: 'maui', bin: 'deep', sites: 30, sedimentPercent: 16.161, turfPercent: 56.181, corallinePercent: 2.223, macroalgaePercent: 4.789, coralPercent: 20.522 },
  { island: 'molokai', bin: 'shallow', sites: 50, sedimentPercent: 4.314, turfPercent: 69.734, corallinePercent: 5.094, macroalgaePercent: 8.975, coralPercent: 11.4 },
  { island: 'molokai', bin: 'mid', sites: 73, sedimentPercent: 6.101, turfPercent: 60.616, corallinePercent: 2.369, macroalgaePercent: 11.175, coralPercent: 19.701 },
  { island: 'molokai', bin: 'deep', sites: 49, sedimentPercent: 5.622, turfPercent: 69.18, corallinePercent: 2.082, macroalgaePercent: 8.709, coralPercent: 14.366 },
  { island: 'lanai', bin: 'shallow', sites: 34, sedimentPercent: 3.403, turfPercent: 75.802, corallinePercent: 1.484, macroalgaePercent: 2.265, coralPercent: 17.006 },
  { island: 'lanai', bin: 'mid', sites: 59, sedimentPercent: 4.854, turfPercent: 61.942, corallinePercent: 1.899, macroalgaePercent: 4.936, coralPercent: 26.334 },
  { island: 'lanai', bin: 'deep', sites: 26, sedimentPercent: 10.255, turfPercent: 62.234, corallinePercent: 1.533, macroalgaePercent: 6.633, coralPercent: 19.306 },
  { island: 'kahoolawe', bin: 'shallow', sites: 26, sedimentPercent: 1.477, turfPercent: 69.365, corallinePercent: 3.814, macroalgaePercent: 6.729, coralPercent: 18.589 },
  { island: 'kahoolawe', bin: 'mid', sites: 38, sedimentPercent: 8.746, turfPercent: 62.586, corallinePercent: 1.025, macroalgaePercent: 6.042, coralPercent: 21.565 },
  { island: 'kahoolawe', bin: 'deep', sites: 28, sedimentPercent: 20.177, turfPercent: 63.003, corallinePercent: 1.183, macroalgaePercent: 4.765, coralPercent: 10.776 },
];
